// extracted by mini-css-extract-plugin
export default {"inputContainer":"OrgAssessmentUsers_inputContainer__GyqfM"};